<template>
	<div class="story-stage" aria-label="Payments for life beyond the checkout">
		<div class="story-panels" :style="{ gridTemplateColumns: columns }" @scroll="onScroll">
			<button v-for="(story, index) in stories" :key="story.name" type="button" :class="['story-panel', { active: active === index }]" :aria-pressed="active === index" :aria-label="`Show ${story.name}`" @click="select(index)">
				<img :src="story.image" :alt="story.alt" width="1122" height="1402" :fetchpriority="index === 0 ? 'high' : null" />
				<span class="story-panel-shade" />
				<span class="story-panel-content"><span>{{ story.label }}</span><strong>{{ story.name }}</strong><ArrowUpRight :size="23" aria-hidden="true" /></span>
			</button>
		</div>
		<div class="story-caption">
			<span>REAL LIFE / REAL REASONS</span>
			<strong :key="active">{{ stories[active].line }}</strong>
			<div class="story-progress" aria-hidden="true"><i :key="active" :class="playing ? 'playing' : ''" /></div>
			<span>{{ String(active + 1).padStart(2, "0") }} / 03</span>
		</div>
	</div>
</template>

<script setup>
import { computed, onBeforeUnmount, ref, watch } from "vue";
import { ArrowUpRight } from "lucide-vue-next";
import { stories } from "@/content/home";

const active = ref(0);
const playing = ref(true);
const columns = computed(() => stories.map((_, index) => (index === active.value ? "1.5fr" : "1fr")).join(" "));
let timer = null;

function select(index) {
	active.value = index;
	playing.value = false;
}

function onScroll(event) {
	if (window.innerWidth > 680) return;
	const row = event.currentTarget;
	const width = row.firstElementChild ? row.firstElementChild.getBoundingClientRect().width : 1;
	select(Math.min(stories.length - 1, Math.round(row.scrollLeft / (width + 8))));
}

watch(playing, (isPlaying) => {
	window.clearInterval(timer);
	if (!isPlaying || window.matchMedia("(prefers-reduced-motion: reduce), (max-width: 680px)").matches) return;
	timer = window.setInterval(() => { active.value = (active.value + 1) % stories.length; }, 6500);
}, { immediate: true });

onBeforeUnmount(() => window.clearInterval(timer));
</script>
